import { combineReducers } from 'redux';

import { keepSession as authentication } from './authentication/authentication';
import { captcha } from './captcha/captcha';
import { exchange } from './exchange/exchange';
import { modals } from './modals';
import { pagination } from './pagination/pagination';
import {
  apiReadOnlyFields,
  attemptedInvalidSMSNumber,
  autoLoadOnlineScript,
  createPaymentFailure,
  currentStepIndex,
  docCollectorFinished,
  duplicatedPANNumber,
  duplicatedPayment,
  embedded,
  embeddedConfirmationStep,
  fieldValues,
  gatewayOrigin,
  gatewaySource,
  hideCancelPaymentOption,
  hideUserManagement,
  isChatVisible,
  isDocumentsFetchFailure,
  isImpersonatingUser,
  isPaymentProcess,
  isRepeatingPayment,
  isTrackingPage,
  lastPaymentFromSameRecipient,
  locale,
  maxAmount,
  notifications,
  paymentsFromIndia,
  prefilledFields,
  prefilledRejectOrConfirm,
  readOnlyFields,
  receiveSMSNotification,
  receiveWhatsappNotification,
  redirectToReferrer,
  refundKYCProcessCompleted,
  rewardsCurrency,
  showOfflineInstructions,
  taxServiceUnavailable,
  theme,
  userExists,
  validRefundKYCToken,
} from './ui';

const ui = combineReducers({
  apiReadOnlyFields,
  attemptedInvalidSMSNumber,
  authentication,
  autoLoadOnlineScript,
  createPaymentFailure,
  currentStepIndex,
  docCollectorFinished,
  duplicatedPayment,
  duplicatedPANNumber,
  embedded,
  embeddedConfirmationStep,
  exchange,
  fieldValues,
  gatewayOrigin,
  gatewaySource,
  hideCancelPaymentOption,
  hideUserManagement,
  isChatVisible,
  isDocumentsFetchFailure,
  isImpersonatingUser,
  isPaymentProcess,
  isRepeatingPayment,
  isTrackingPage,
  lastPaymentFromSameRecipient,
  locale,
  maxAmount,
  modals,
  notifications,
  pagination,
  paymentsFromIndia,
  rewardsCurrency,
  prefilledFields,
  prefilledRejectOrConfirm,
  readOnlyFields,
  receiveSMSNotification,
  receiveWhatsappNotification,
  redirectToReferrer,
  refundKYCProcessCompleted,
  showOfflineInstructions,
  taxServiceUnavailable,
  theme,
  userExists,
  validRefundKYCToken,
  captcha,
});

export { ui };
